import { Button, type ButtonProps } from "@mantine/core"

export function ButtonQuestion({ preview, ...props }: ButtonProps & { onClick: () => void; preview?: boolean }) {
  return <Button fz="lg" size={preview ? "compact-md" : "lg"} {...props} />
}
